
import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';

export default function WhatsAppButton() {
  const [whatsappNumber, setWhatsappNumber] = useState('');

  useEffect(() => {
    loadWhatsAppNumber();
    
    // Her 3 saniyede bir kontrol et
    const interval = setInterval(() => {
      loadWhatsAppNumber();
    }, 3000);
    
    return () => {
      clearInterval(interval);
    };
  }, []);

  const loadWhatsAppNumber = async () => {
    try {
      const { data, error } = await supabase
        .from('site_settings')
        .select('whatsapp_number')
        .eq('setting_key', 'site_settings')
        .maybeSingle();

      if (error && error.code !== 'PGRST116') {
        console.error('WhatsApp numarası yüklenemedi:', error);
        return;
      }
      
      if (data?.whatsapp_number) {
        const cleanNumber = String(data.whatsapp_number).trim();
        console.log('WhatsApp numarası yüklendi:', cleanNumber);
        setWhatsappNumber(cleanNumber);
      } else {
        console.log('WhatsApp numarası bulunamadı');
      }
    } catch (error) {
      console.error('WhatsApp numarası yüklenirken hata:', error);
    }
  };

  const handleClick = () => {
    if (!whatsappNumber) {
      alert('WhatsApp numarası ayarlanmamış.');
      return;
    }
    
    const cleanNumber = whatsappNumber.replace(/[^0-9]/g, '');
    window.open(`https://wa.me/${cleanNumber}`, '_blank');
  };

  // Numara yoksa butonu gösterme
  if (!whatsappNumber || whatsappNumber.trim() === '') {
    return null;
  }

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 w-16 h-16 flex items-center justify-center bg-[#25D366] text-white rounded-full shadow-2xl hover:bg-[#20BA5A] transition-all cursor-pointer z-[9999] hover:scale-110"
      aria-label="WhatsApp ile iletişime geç"
      title="WhatsApp ile iletişime geç"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
    </button>
  );
}
